import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaYoutube, FaFacebookF } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import logo from '../../images/mcb-logo.png';

export default function Footer() {
  return (
    <footer style={{
      background: "#fff",
      borderTop: "3px solid #7a1428",
      fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&display=swap');
        .mcb-footer-link {
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          color: #555;
          text-decoration: none;
          transition: color 0.15s;
          line-height: 1.8;
          display: block;
        }
        .mcb-footer-link:hover { color: #7a1428; }
        .mcb-social {
          width: 36px; height: 36px;
          display: flex; align-items: center; justify-content: center;
          border-radius: 50%;
          border: 1.5px solid #ddd;
          color: #555;
          text-decoration: none;
          transition: border-color 0.15s, color 0.15s, background 0.15s;
          font-size: 14px;
        }
        .mcb-social:hover {
          border-color: #7a1428;
          color: #7a1428;
          background: rgba(122,20,40,0.05);
        }
      `}</style>

      {/* Main footer body */}
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "60px 40px 40px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1.8fr 1fr 1fr 1fr", gap: 48 }}>

          {/* Brand */}
          <div>
            <Link to="/">
              <img src={logo} alt="McCallum Bros Ltd" style={{ height: 56, width: "auto", objectFit: "contain", marginBottom: 20 }} />
            </Link>
            <p style={{ fontSize: 14, lineHeight: 1.8, color: "#666", maxWidth: 280, fontWeight: 300 }}>
            </p>
            <div style={{ marginTop: 24, display: "flex", gap: 10 }}>
              <a href="#" className="mcb-social"><FaFacebookF /></a>
              <a href="#" className="mcb-social"><FaLinkedinIn /></a>
              <a href="#" className="mcb-social"><FaXTwitter /></a>
              <a href="#" className="mcb-social"><FaYoutube /></a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#7a1428", marginBottom: 20 }}>
              Services
            </h4>
            {[
              { label: "Maritime Services", to: "/services" },
              { label: "Sand & Aggregates", to: "/products" },
              { label: "Road Transport", to: "/transport" },
              { label: "Vessel Charter", to: "/services" },
              { label: "Beach Replenishment", to: "/services" },
            ].map(item => (
              <Link key={item.label} to={item.to} className="mcb-footer-link">{item.label}</Link>
            ))}
          </div>

          {/* Company */}
          <div>
            <h4 style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#7a1428", marginBottom: 20 }}>
              Company
            </h4>
            {[
              { label: "Our Story", to: "/about" },
              { label: "Our Fleet", to: "/services" },
              { label: "Gallery", to: "/gallery" },
              { label: "News", to: "/news" },
              { label: "Contact", to: "/contact" },
            ].map(item => (
              <Link key={item.label} to={item.to} className="mcb-footer-link">{item.label}</Link>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "#7a1428", marginBottom: 20 }}>
              Contact
            </h4>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                { label: "Address", value: "747 Rosebank Road\nAvondale, Auckland 1348" },
                { label: "Phone", value: "(09) 828 5202" },
                { label: "Email", value: "dispatch@mccallumbros.co.nz" },
                { label: "EQ3 Sales", value: "Dion — 021 275 9218" },
              ].map(item => (
                <div key={item.label}>
                  <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#aaa", marginBottom: 2 }}>{item.label}</div>
                  <div style={{ fontSize: 14, color: "#444", lineHeight: 1.6, whiteSpace: "pre-line" }}>{item.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{ background: "#f7f4f1", borderTop: "1px solid #ede8e2" }}>
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "16px 40px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <p style={{ fontSize: 12, color: "#999", fontFamily: "'DM Sans', sans-serif" }}>
            © {new Date().getFullYear()} McCallum Bros Limited®. All rights reserved.
          </p>
          <div style={{ display: "flex", gap: 24 }}>
            {[
              { label: "Privacy Policy", to: "/privacy" },
              { label: "Terms", to: "/terms" },
              { label: "Staff Login", to: "/login" },
            ].map(item => (
              <Link key={item.label} to={item.to} style={{ fontSize: 12, color: "#999", textDecoration: "none", transition: "color 0.15s", fontFamily: "'DM Sans', sans-serif" }}
                onMouseOver={e => e.target.style.color = "#7a1428"}
                onMouseOut={e => e.target.style.color = "#999"}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}